import { createContext, useContext, useState, useEffect } from 'react';
import api from '@/services/api'; // Check if api exists or axios

export const PlatformSettingsContext = createContext({
  settings: null,
  loading: true
});

export const PlatformSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/settings/public')
      .then((res) => {
        const data = res.data?.data;
        if (data?.platform) {
          // Handle relative /uploads/ paths for assets
          const resolveUrl = (url) => url?.startsWith('/uploads') ? `${import.meta.env.VITE_API_URL.replace(/\/api\/v1\/?$/, '')}${url}` : url;

          const logoUrl = resolveUrl(data.platform.logo);
          const faviconUrl = resolveUrl(data.platform.favicon || data.platform.logo);

          setSettings({ ...data.platform, logo: logoUrl, favicon: faviconUrl });

          // Update favicon dynamically
          if (faviconUrl) {
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
              link = document.createElement('link');
              link.rel = 'icon';
              document.head.appendChild(link);
            }
            link.href = faviconUrl;
          }
        }
          // Update title if needed
          // if (data.platform.platformName?.ar) {
          //   document.title = `${data.platform.platformName.ar} - لوحة الإدارة`;
          // }
      })
      .catch((err) => console.error('Failed to fetch platform settings:', err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <PlatformSettingsContext.Provider value={{ settings, loading }}>
      {children}
    </PlatformSettingsContext.Provider>
  );
};

export const usePlatformSettings = () => useContext(PlatformSettingsContext);
